export default __webpack_public_path__ + "static/media/dconfig.c722ca41.png";